<script setup>

import { reactive, ref, unref } from 'vue'
import { TABLE_DEFAULT_SELECTED_GRID_SIZE, TABLE_INIT_GRID_SIZE, TABLE_MAX_GRID_SIZE } from '@/tiptap/constants/define.js'
import { useLocale } from '@/tiptap/locales/index.js'

import { isMobile } from '@/tiptap/utils/is-mobile.js'

const emit = defineEmits(['create-table'])

const { t } = useLocale()

const menu = ref(false)
const withHeaderRow = ref(true)
const tableGridSize = reactive({
  rows: isMobile() ? TABLE_MAX_GRID_SIZE : TABLE_INIT_GRID_SIZE,
  cols: isMobile() ? TABLE_MAX_GRID_SIZE : TABLE_INIT_GRID_SIZE
})

const selectedTableGridSize = reactive({
  rows: TABLE_DEFAULT_SELECTED_GRID_SIZE,
  cols: TABLE_DEFAULT_SELECTED_GRID_SIZE
})

function cellInnerStyles(row, col) {
  const values = {
    boxSizing: 'border-box',
    width: '16px',
    height: '16px',
    padding: '4px',
    border: '1px solid #dcdfe6',
    borderRadius: '2px'
  }

  if (col <= selectedTableGridSize.cols && row <= selectedTableGridSize.rows) {
    values.backgroundColor = '#ecf5ff'
    values.borderColor = 'var(--vp-theme-primary)'
  }

  return values
}

function selectTableGridSize(rows, cols) {
  if (rows === tableGridSize.rows) {
    tableGridSize.rows = Math.min(rows + 1, TABLE_MAX_GRID_SIZE)
  }

  if (cols === tableGridSize.cols) {
    tableGridSize.cols = Math.min(cols + 1, TABLE_MAX_GRID_SIZE)
  }

  selectedTableGridSize.rows = rows
  selectedTableGridSize.cols = cols
}

function onMouseDown(rows, cols) {
  emit('create-table', { rows, cols, withHeaderRow: unref(withHeaderRow) })
  resetTableGridSize()
}

function resetTableGridSize() {
  menu.value = false
  withHeaderRow.value = true

  tableGridSize.rows = TABLE_INIT_GRID_SIZE
  tableGridSize.cols = TABLE_INIT_GRID_SIZE

  selectedTableGridSize.rows = TABLE_DEFAULT_SELECTED_GRID_SIZE
  selectedTableGridSize.cols = TABLE_DEFAULT_SELECTED_GRID_SIZE
}
</script>

<template>
  <VMenu
    v-model="menu"
    location="end bottom"
    open-on-click
    open-on-hover
    :close-on-content-click="false"
    activator="parent"
  >
    <VCard density="compact">
      <VCardText class="pa-2 pb-0">
        <VCheckbox
          v-model="withHeaderRow"
          density="compact"
          hide-details
          :label="t('editor.table.menu.insert_table.with_header_row')"
        />
      </VCardText>

      <VCardText class="d-flex flex-column flex-wrap justify-space-between pa-2">
        <div v-for="row in tableGridSize.rows" :key="'r' + row" class="d-flex">
          <div
            v-for="col in tableGridSize.cols"
            :key="'c' + col"
            class="pa-1"
            @mouseover="selectTableGridSize(row, col)"
            @mousedown="onMouseDown(row, col)"
          >
            <div :style="cellInnerStyles(row, col)"></div>
          </div>
        </div>
      </VCardText>

      <VCardSubtitle class="pt-0 pb-2">
        {{ selectedTableGridSize.rows }} x {{ selectedTableGridSize.cols }}
      </VCardSubtitle>
    </VCard>
  </VMenu>
</template>